export default __webpack_public_path__ + "static/media/babavelisekiz6.09bf365d.jpg";